import { authFetch } from '../utils/authFetch';
import {baseUrl} from '../utils/requestUrl'

const carePlanScoresUrl = (patientId) =>
    `${baseUrl}/careplans/byPatient/${patientId}/scores`;

// Earliest signed score per subheading. For INDIVIDUAL this is scoped to the
// logged-in provider's own assessments, so a provider who has never assessed
// this patient gets an empty map — that is not an error, render blanks.
export const fetchCarePlanInitialScores = async (patientId, carePlanType) => {
    const response = await authFetch(`${carePlanScoresUrl(patientId)}/initial?type=${carePlanType}`);
    return response.json();
}

// Latest score per subheading. The date range narrows which team-score batches
// are considered and is honoured for COLLABORATIVE only, so it isn't sent for
// INDIVIDUAL.
export const fetchCarePlanCurrentScores = async (patientId, carePlanType, fromDate, toDate) => {
    let url = `${carePlanScoresUrl(patientId)}/current?type=${carePlanType}`;
    if (carePlanType === 'COLLABORATIVE') {
        if (fromDate) url += `&from_date=${fromDate}`;
        if (toDate) url += `&to_date=${toDate}`;
    }
    const response = await authFetch(url);
    return response.json();
}

// Median score per subheading over a date range, across every provider who
// assessed the patient — there is no type, a median is an aggregate over
// assessors. Values come back already floored to the 1-5 scale.
export const fetchCarePlanMedianScores = async (patientId, fromDate, toDate) => {
    const params = [];
    if (fromDate) params.push(`from_date=${fromDate}`);
    if (toDate) params.push(`to_date=${toDate}`);
    const url = `${carePlanScoresUrl(patientId)}/median${params.length ? `?${params.join('&')}` : ''}`;
    const response = await authFetch(url);
    return response.json();
}

export  const fetchPositions = async() => {
    const organizationId = JSON.parse(localStorage.getItem('user')).organizations?.find((org)=>org.active === true)?.id;
    const response = await authFetch(`${baseUrl}/careProviders/byOrganization/${organizationId}`);
    
    return response.json(); 
}
export const fetchInterventions = async () => {
    const organizationId = JSON.parse(localStorage.getItem('user')).organizations?.find((org)=>org.active === true)?.id
    const response = await authFetch(`${baseUrl}/careplans/interventions/${organizationId}`);

    return response.json();
}
export const fetchMeetingTypes = async () => {
    const organizationId = JSON.parse(localStorage.getItem('user')).organizations?.find((org)=>org.active === true)?.id;
    const response = await authFetch(`${baseUrl}/meetingTypes/organizations/${organizationId}`);

    return response.json();
}
export const createCarePlan = async(carePlan) => {
    const response = await authFetch(`${baseUrl}/careplans`,{
        method:'POST',
        body:JSON.stringify(carePlan),
    })
    return response.json()
}
export const fetchCarePlans = async(startDate = null, endDate = null, carePlanTypes = null, meetingTypes = null, authorIds = null, pageNumber = 1, pageSize = 10) =>{
    const patientId = localStorage.getItem('patient')
    const providerId = JSON.parse(localStorage.getItem('user')).organizations[0].careProvider.id
    let url = `${baseUrl}/careplans/byPatient/${patientId}?providerId=${providerId}`;

    // Care Plan Summaries only lists signed (current) plans; drafts live in
    // Outstanding Documents.
    url += `&status=SIGNED`;

    // Add pagination parameters
    url += `&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    url += `&includeHistory=true`; // Include historical care plans in the response
    
    // Add date parameters if provided
    if (startDate) {
        url += `&startDate=${startDate}`;
    }
    if (endDate) {
        url += `&endDate=${endDate}`;
    }
    
    // Add care plan type parameters if provided
    if (carePlanTypes && carePlanTypes.length > 0) {
        url += `&type=${carePlanTypes.join(',')}`;
    }
    
    // Add meeting type parameters if provided
    if (meetingTypes && meetingTypes.length > 0) {
        url += `&typeOfMeeting=${meetingTypes.join(',')}`;
    }
    
    // Add author parameters if provided
    if (authorIds && authorIds.length > 0) {
        url += `&authorIds=${authorIds.join(',')}`;
    }
    
    const response = await authFetch(url);
    return response.json()
}

export const fetchCarePlanById = async(carePlanId) => {
    const response = await authFetch(`${baseUrl}/careplans/${carePlanId}?includeAll=true`);
    return response.json();
}

export const updateCarePlan = async(carePlanId, carePlan) => {
    const response = await authFetch(`${baseUrl}/careplans/${carePlanId}`, {
        method: 'PUT',
        body: JSON.stringify(carePlan),
    });
    return response.json();
}

export const amendCarePlan = async(carePlanId, editReason) => {
    const response = await authFetch(`${baseUrl}/careplans/${carePlanId}/amend`, {
        method: 'POST',
        body: JSON.stringify({ editReason }),
    });
    return response.json();
}

export const fetchPatientPermissions = async () => {
    const patientId = localStorage.getItem('patient');
    const providerId = JSON.parse(localStorage.getItem('user')).organizations[0].careProvider.id;
    const response = await authFetch(`${baseUrl}/careProviders/${providerId}/patients/${patientId}/permissions`);
    return response.json();
}
